import React, { useState } from "react";
import CloseIcon from "../Assets/svgs/CloseIcon";
import CheckIcon from "../Assets/svgs/CheckIcon";
import ModernCopyIcon from "../Assets/svgs/ModernCopyIcon";
import { copyToClipboard } from "./utils";
import { Tooltip } from "@mui/material";

const ShareLinkModal = ({ url, onClose }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const onClickCopy = () => {
    copyToClipboard(url);
    setIsCopied(true);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2000);
  };

  return (
    <div className="modal modal--modalCredits modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header">
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <span className="icon">
              <CheckIcon />
            </span>
            <div className="form__group form__group--inviteUrl">
              <label className="form__label">Copy Form URL</label>
              <div className="form__Field form__Field--flexBox">
                <input
                  type="url"
                  id="url"
                  disabled
                  className="form__input form__input--sm"
                  value={url}
                />
                <Tooltip
                  title={isCopied ? "Copied" : "Copy"}
                  placement="top"
                  className="btn btn__primary m_0"
                  arrow
                  open={open}
                >
                  <button
                    className="btn btn__primary m_0"
                    onClick={onClickCopy}
                  >
                    <ModernCopyIcon />
                    Copy
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default ShareLinkModal;
